import { render, staticRenderFns } from "./Messaggi.vue?vue&type=template&id=603e9719"
import script from "./Messaggi.vue?vue&type=script&lang=js"
export * from "./Messaggi.vue?vue&type=script&lang=js"
import style0 from "./Messaggi.vue?vue&type=style&index=0&id=603e9719&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports